import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS, SELLER_DESCRIPTION_TEST_ID} from './config.js'

const PanelAdDetailsVehicleComments = ({ad}) => {
  const {i18n} = useContext(Context)
  const {description: adDescription} = ad

  return (
    <div className={`${BASE_CLASS}-comments`}>
      <TitleBasic
        as={titleBasicTags.h2}
        color={titleBasicColors.black}
        size={titleBasicSizes.xs}
        title={i18n.t('COMMON_SELLER_COMMENTS')}
      />
      <div className={`${BASE_CLASS}-commentsContent`} data-testid={SELLER_DESCRIPTION_TEST_ID}>
        {htmlStringToReactElement(adDescription)}
      </div>
    </div>
  )
}

PanelAdDetailsVehicleComments.propTypes = {
  ad: PropTypes.object
}

export default PanelAdDetailsVehicleComments
